import { defineField, defineType } from "sanity";
import { designSystemIconPreview } from "../../components/DesignSystemIconInput";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "cardComparisonItem",
  type: "object",
  title: "Card Comparison Item",
  fields: [
    defineField({
      name: "icon",
      title: "Icon",
      type: "designSystemIcon",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "title",
      title: "Title",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "description",
      title: "Description",
      type: "multilingualArrayBlockContent",
      validation: (Rule) => Rule.required()
    })
  ],
  preview: {
    select: {
      title: "title",
      icon: "icon"
    },
    prepare({ title, icon }) {
      return {
        title: multilingualStringPreview(title),
        media: designSystemIconPreview(icon)
      };
    }
  }
});
